/**
 * External dependencies.
 */
import { useSelect } from '@wordpress/data';
import { useState } from '@wordpress/element';

import {
	InspectorControls,
	store as blockEditorStore,
	__experimentalUnitControl as UnitControl // eslint-disable-line
} from '@wordpress/block-editor';
import {
	PanelBody,
	Notice,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies.
 */
import LayoutContent from './layout-content';
import SelectPlaceholder from './select-placeholder';
import PatternSelectionModal from './pattern-selection-modal';

export default ( props ) => {
	const { clientId, attributes, setAttributes, name } = props;
	const { sidebartopoffset } = attributes;

	const [ isPatternSelectionModalOpen, setIsPatternSelectionModalOpen ] = useState( false );

	const hasInnerBlocks = useSelect(
		( select ) => !! select( blockEditorStore ).getBlocks( clientId ).length,
		[ clientId ]
	);

	const Component = hasInnerBlocks ? LayoutContent : SelectPlaceholder;

	return (
		<>
			<Component
				{ ...props }
				openPatternSelectionModal={ () =>
					setIsPatternSelectionModalOpen( true )
				}
			/>

			<InspectorControls>
				<PanelBody>
					<UnitControl
						label={ __( 'Sidebar Top Offset', 'suredash' ) }
						__unstableInputWidth="100px"
						value={ sidebartopoffset }
						onChange={ ( sidebartopoffset ) => setAttributes( { sidebartopoffset } ) } // eslint-disable-line
					/>
					<Notice status="info" className="suredash-block-settings-notice" isDismissible={ false }>
						{ __( 'Set the top offset for the sticky sidebar to ensure it stays in place and provides a smooth scrolling experience.', 'suredash' ) }
					</Notice>
				</PanelBody>
			</InspectorControls>

			{ isPatternSelectionModalOpen && (
				<PatternSelectionModal
					clientId={ clientId }
					attributes={ attributes }
					setIsPatternSelectionModalOpen={
						setIsPatternSelectionModalOpen
					}
					name={ name }
					hasExistingPattern={ hasInnerBlocks }
				/>
			) }
		</>
	);
};
